import { render, staticRenderFns } from "./MostrarDetalles.vue?vue&type=template&id=c1007eaa"
import script from "./MostrarDetalles.vue?vue&type=script&lang=js"
export * from "./MostrarDetalles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports